const AppLabRad =()=> import('./lab-rad.vue');
//dummy holders
import { guardRoute } from '../guardRouter';

//config
// const LabRadConfig = () => import('./lab-rad-configuration/lab-rad-configuration.vue')
// const InvestigationAbsoluteValues = () => import('./lab-rad-configuration/investigation-absolute-values/investigation-absolute-values.vue')

// receive orders
const BloodBankInvestigations = () => import('./blood-bank-investigations/blood-bank-investigations.vue')

// Donations investigations
const DonationsInvestigations = () => import('./blood-bank-investigations/donations-investigations/donations-investigations.vue')


// receive orders
const LabRadSetup = () => import('./lab-rad-setup/lab-rad-setup.vue')

// Donations investigations
const AnalyzerManagement = () => import('./lab-rad-setup/analyzer-management/analyzer-management.vue')

//microbiology setup
const MicrobiologySetup = () => import('./microbiology-setup/microbiology-setup.vue')
const MicrobiologyOrganismSetup = () => import('./microbiology-setup/microbiology-organism-setup/microbiology-organism-setup.vue')
const MicrobiologyAntibioticSetup = () => import('./microbiology-setup/microbiology-organism-setup/antibiotic-setup/antibiotic-setup.vue')

import localeEn from '../../locales/en'
import localeAr from '../../locales/ar'

export const translation = {
    en: {
        ...localeEn
    },
    ar: {
        ...localeAr
    }
}


const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');

const labRadRoutes = [
    {
        path: '/lab-rad',
        name: 'app.LapRad',
        component: AppLabRad,
        meta: {
            title: translation[lang].Nav.LabRad.LabRad,
        },
        children: [
      
            {
                path: 'blood-bank-investigations',
                name: '/lab-rad/blood-bank-investigations',
                meta: {
                    title: translation[lang].Nav.LabRad.BloodBankInvestigations,//"blood-bank-investigations"
                },
                component: BloodBankInvestigations,
                children: [
                    {
                        path: 'donations-investigations',
                        name: '/lab-rad/blood-bank-investigations/donations-investigations',
                        meta: {
                            title: translation[lang].Nav.LabRad.DonationsInvestigations,
                        },
                        component: DonationsInvestigations
                    }
                ]
            },

            {
                path: 'lab-rad-setup',
                name: '/lab-rad/lab-rad-setup',
                meta: {
                    title: translation[lang].Nav.LabRad.LabRadSetup,//"blood-bank-investigations"
                },
                component: LabRadSetup,
                children: [
                    {
                        path: 'analyzer-management',
                        name: '/lab-rad/lab-rad-setup/analyzer-management',
                        meta: {
                            title: translation[lang].Nav.LabRad.AnalyzerManagement,
                        },
                        component: AnalyzerManagement
                    }
                ]
            },
            {
                path: 'microbiology-setup',
                name: 'microbiology-setup',
                meta: {
                    title: translation[lang].Nav.Microbiology.MicrobiologySetup,//"blood-bank-investigations"
                
                },
                component: MicrobiologySetup,
                children: [
                    {
                        path: 'microbiology-organism-setup',
                        name: 'microbiology-organism-setup',
                        meta: {
                            title: translation[lang].Nav.LabRad.MicrobiologyOrganismSetup,//"blood-bank-investigations"
                            clickable: true
                        },
                        component: MicrobiologySetup,
                        children: [
                            {
                                path: '',
                                name: 'lab-rad/microbiology-setup/microbiology-organism-setup',
                                
                                 meta: {
                                    title: translation[lang].Nav.LabRad.MicrobiologyOrganismSetup,//"blood-bank-investigations"
                                     hide: true
                                },
                                component: MicrobiologyOrganismSetup,

                            },
                            {
                                path: 'add-edit-Antibiotic',
                                name: 'lab-rad/microbiology-setup/microbiology-organism-setup/add-edit-Antibiotic',
                                meta: {
                                    title: translation[lang].Nav.Microbiology.OrganismSetup,
                                },
                                component: MicrobiologyAntibioticSetup,
                                props: true
                            }
                        ]

                    }
                ]
                
            }
        ],
        beforeEnter: guardRoute
    }
];

export default labRadRoutes;
